<style>
    .ivu-vueEditBox {
        width : 100%;
        height : 100%;
    }
    .ivu-vueEditBox-div {
        width : 100%;
        height : 100%;
        position: absolute;
        padding : 0;
    }
    .delData{
        position:absolute;
        color:#808695;
        text-align:center;
        top:5px;
        right:5px;
        cursor:pointer;
    }
</style>
<template>
    <div class="ivu-vueEditBox-div" v-if="isShow" :style="EditBoxStyle">
        <div v-if="textType != 'password'">
            <textarea v-model="textValue" :placeholder="message" :readonly="readonly" :disabled ="isEnable" :style="textareaStyle" style="resize:none;"
            :wrap="wrap" @blur="onBlur" @focus="onFocus" @input="onInput"  ref="focu" autocomplete="off" :type="textType"></textarea>
        </div>
        <div v-else>
            <input  v-model="textValue" :placeholder="message" :readonly="readonly" :disabled ="isEnable" :style="textareaStyle"
            :wrap="wrap" @blur="onBlur" @focus="onFocus" @input="onInput"  ref="focu" autocomplete="off" :type="textType" />
        </div>
        <span class="delData" v-show="delContent" @click="clearData"><Icon type="ios-close" size="20"/></span>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
import { setTimeout } from 'timers';
export default {
    name : "fvEditBox",
    props : ["primitives","fvSystemApi","parentObject",],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            EditBoxStyle : "",
            isShow : true,
            isEnable : false,
            textValue:"",
            readonly:false,
            textareaStyle:{},
            message:this.placeholder,
            delContent:false,
            BackColors : "",
            FontColors : "",
        }
    },
    methods : {   
        /**多选框 */
        create(){
            this.mixin(this.primitives);
            this.windowsObject = this.$parent.$parent;
            this.workbench = this.windowsObject.workbench;
            //初始化位置
            this.EditBoxStyle = {
                left : 0 + "px",
                top : 0 + "px",
                width : 0 + "px",
                height : 0 + "px"
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
            var temptextValue = this.value || this.placeholder;
            temptextValue = this.fvSystemApi.getResource(temptextValue);
            if(temptextValue){
                this.textValue = temptextValue;
            }else{
                this.textValue = this.value || this.placeholder;
            }
            if(isNaN(this.backgroundColor) || isNaN(this.fontColor)){
                this.textareaStyle.backgroundColor=this.backgroundColor;
                this.textareaStyle.color=this.fontColor;
            }else{
                var colors = FColorToRGB.getColors();
                //背景色
                var rgb = "RGB(" + colors[this.backgroundColor][0] + "," + colors[this.backgroundColor][1] + "," + colors[this.backgroundColor][2] +")";
                this.textareaStyle.backgroundColor = rgb;
            
                //字体颜色
                rgb = "RGB(" + colors[this.fontColor][0] + "," + colors[this.fontColor][1] + "," + colors[this.fontColor][2] +")";
                this.textareaStyle.color = rgb;
            }
            
            //字号
           // this.textareaStyle.fontSize = this.fontSize;
            //加粗
            if(this.fontWeight)this.textareaStyle.fontWeight = "bold";
            //斜体
            if(this.fontStyle)this.textareaStyle.fontStyle = "oblique";
            //设置字体样式
            this.textareaStyle.fontFamily = this.getFontFamily(this.fontName);
            if(this.editStyle.autoVScroll==1 || this.editStyle.vScroll==1){
                this.textareaStyle.overflowX = "hidden";
                this.textareaStyle.overflowY = "scroll";
                // this.wrap = 'off';
            }
            // else{
            //     //是否多行
            // this.wrap = this.editStyle.multiLine ? "hard" : "off";
            // }
            if(this.editStyle.multiLine==1){
                this.wrap="hard"
            }else{
                this.wrap="off"
            }
            // this.wrap = this.editStyle.multiLine ? "hard" : "off";
            //是否只读
            if(this.editStyle.readOnly != 0){
                this.readonly = true;
            }
            
            //是否具有边框
            if(this.editStyle.border == 0){
                this.textareaStyle.borderStyle = "none";
            }
            //滚动条相关
            if(this.editStyle.autoHScroll!=0){
                this.textareaStyle.overflowX = "scroll";
                this.textareaStyle.overflowY = "hidden";
            }
            
            if(this.editStyle.hScroll!=0){
                this.textareaStyle.overflowX = "scroll";
            }
            //大小写相关
            switch(this.editStyle.case){
                case 1:
                    this.placeholder.toLowerCase();
                break;
                case 2:
                    this.placeholder.toUpperCase();
                break;
            }

            switch(this.align){
                case 0:
                 this.textareaStyle.textAlign = "left";
                break;
                case 1:
                 this.textareaStyle.textAlign = "right";
                break;
                case 2:
                 this.textareaStyle.textAlign = "center";
                break;
                default:
                 this.textareaStyle.textAlign = "left";
                break;
            }

            //密码形式暂无实现
            if(this.editStyle.password){
                this.textType = "password";
            }else{
                this.textType = "text";
            }
            // 属性监听
            this.moniter();
        }, 
        // 用于设置获取字体库 ，参数为字体
        getFontFamily(name){
            var fontList={
                "宋体": "SimSun",
                "黑体": "SimHei",
                "微软雅黑": "Microsoft YaHei",
                "微软正黑体": "Microsoft JhengHei",
                "新宋体": "NSimSun",
                "新细明体": "PMingLiU",
                "细明体": "MingLiU",
                "标楷体": "DFKai-SB",
                "仿宋": "FangSong",
                "楷体":"_GB2312 KaiTi_GB2312",
                "隶书":"LiSu",
                "幼圆":"YouYuan",

                "华文细黑":"STXihei",
                "华文楷体":"STKaiti",
                "华文宋体":"STSong",
                "华文中宋":"STZhongsong",
                "华文仿宋":"STFangsong",
                "方正舒体":"FZShuTi",
                "方正姚体":"FZYaoti",
                "华文彩云":"STCaiyun",
                "华文琥珀":"STHupo",
                "华文隶书":"STLiti",
                "华文行楷":"STXingkai",
                "华文新魏":"STXinwei"
            }
            for(var k in fontList){
                if(name == k){
                    return fontList[k];
                }
            }
            
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},

        setZoomMultiple(multiple){
            this.zoomMultiple = multiple;
        },

        reDraw(scaleObj){
            //this.textareaStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            this.EditBoxStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.EditBoxStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.EditBoxStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            if(parseInt(this.height * (scaleObj.sy + scaleObj.zoom))<18){
                this.EditBoxStyle.height = 18 + "px";
            }else{
                this.EditBoxStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            }
            this.textareaStyle.width = this.EditBoxStyle.width;
            this.textareaStyle.height = this.EditBoxStyle.height;
            
        },

        onTimer(){
            if(this.isEnable) return;
        },

        Show(isShow){
            this.isShow = isShow ? true:false;
        },

        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },

        /*
            参数：
            作用：使文本框得到焦点
        */
        SetFocus(){
            // this.isfocus = false;
            this.$refs.focu.focus();
        },

        /*
            参数：
            作用：使文本框失去焦点
        */
        KillFocus(){
            // this.isfocus = true;
            this.$refs.focu.blur();
        },

        Invalidate(){
            var obj = this.fvSystemApi.isDbVar(this.textValue);
            if(obj){
                for(var k in obj){
                    this.textValue = obj[k].PV;
                }
            }
        },

        /*
            参数：
            作用：失去焦点事件
        */
        onBlur(){
            if(this.text){
                if(!this.isNumber(this.textValue)){
                    if(this.textValue != ""){
                        var errNum = "输入数据不符合要求";
                        this.textValue = "";
                        this.message = errNum;
                    }else{
                        this.textValue = this.value || this.placeholder;
                    }
                }else{
                    var temp = parseFloat(this.textValue);
                    this.textValue = temp.toFixed(this.digits);
                    if(temp < this.lowerLimit){
                        this.textValue = this.lowerLimit;
                    }
                    if(temp > this.upperLimit){
                        this.textValue = this.upperLimit;
                    }
                }
            }
            if(this.editStyle.clear){
                setTimeout(() => {
                    this.delContent = false;
                },500)
            }
        },

        // 获取焦点
        onFocus(){
            if(this.editStyle.clear){
                if(this.textValue != ""){
                    if(this.editStyle.clear){
                        this.delContent = true;
                    }
                }
            }
        },

        //清空数据
        clearData(){
            this.textValue = "";
        },

        /*
            参数：
            作用： 事件在用户输入时触发
        */
        onInput(){
            if(this.editStyle.clear){
                this.delContent = true;
            }
            if(this.editStyle.case == 1){
                this.textValue = this.textValue.toLowerCase();
            }else if(this.editStyle.case == 2){
                this.textValue = this.textValue.toUpperCase();
            }
        },

        //判断是否是数字
        isNumber(val) {
            var reg = /^(([^0][0-9]+|0)\.([0-9]{1,10})$)|^([^0][0-9]+|0)$/
            if(reg.test(val)){
                return true
            }else{
                return false
            }
        },

        // 监听属性变化
        moniter(){
            Object.defineProperty(this,"BackColor",{
                set(value){
                    this.BackColors = value;
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    var backgroundColor = "RGB(" + colorTemp[0] + "," + colorTemp[2] + ")";
                    this.$forceUpdate();
                    this.$set(this.textareaStyle,'backgroundColor',backgroundColor);
                },
                get(){
                    return this.BackColors.length != 0 ? this.BackColors : this.backgroundColor;
                }
            })
            Object.defineProperty(this,"FontColor",{
                set(value){
                    this.FontColors = value;
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    var color = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    this.$forceUpdate();
                    this.$set(this.textareaStyle,'color',color);
                },
                get(){
                    return this.FontColors.length != 0 ? this.FontColors : this.fontColor;
                }
            })
            Object.defineProperty(this,"Text",{
                set(value){
                    this.$forceUpdate();
                    this.textValue = value;
                },
                get(){
                    return this.textValue
                }
            })
        }
    },
    mounted() {
        // 横向滚动
        // if(this.editStyle.autoVScroll){
        //     this.textareaStyle.overflowX = "hidden";
        //     this.textareaStyle.overflowY = "auto";
        //     this.$refs.focu.wrap = 'off';
        // };
    }
}
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvEditBox/fvEditBox.vue